module.exports = (phonemes, baseOptions) => {
  if (!phonemes) {
    return '';
  }
  phonemes = phonemes.replace(/ /g, '_');
  baseOptions.setResource({ name: 'pronaudio' });

  return baseOptions.getOptions({ authRequired: false, id: phonemes }).url;
};
